export class SubcontractorTrainingModule {
    id!: string
    title!: string
    description!: string
    youTubeUrl!: string
    isActive = true
    sortOrder = 0
    questions: SubcontractorTrainingQuestion[] = []
}

export class SubcontractorTrainingQuestion {
    id!: string
    moduleId!: string
    sortOrder = 0
    questionText!: string
    questionType: 'TrueFalse' | 'MultipleChoice' = 'TrueFalse'
    optionsJson = ''
    correctAnswer!: string
    explanation = ''
}

export class SubcontractorTrainingSendInviteRequest {
    companyName!: string
    email!: string
    firstName = ''
    lastName = ''
    moduleIds: string[] = []
}

export class SubcontractorTrainingTrackingRow {
    inviteId!: string
    participantId?: string
    id!: string
    companyName!: string
    email!: string
    firstName = ''
    lastName = ''
    participantFirstName = ''
    participantLastName = ''
    moduleTitles!: string
    status!: string
    invitedOn?: Date
    isOverdue = false
    daysSinceInvited = 0
    latestCompletionOn?: Date
    latestScore = ''
    modules: SubcontractorTrainingTrackingModule[] = []

    $deserialize(source: any) {
        this.id = source.inviteId
    }
}

export class SubcontractorTrainingDashboardKpi {
    totalSent = 0
    completed = 0
    pending = 0
    overdue = 0
}

export class SubcontractorTrainingModuleBreakdown {
    moduleId!: string
    moduleTitle!: string
    assigned = 0
    completed = 0
    pending = 0
    overdue = 0
}

export class SubcontractorTrainingOverdueRow {
    inviteId!: string
    companyName!: string
    email!: string
    participantName!: string
    moduleTitles!: string
    status!: string
    invitedOn?: Date
    daysSinceInvited = 0
}

export class SubcontractorTrainingDashboardMetrics {
    kpi = new SubcontractorTrainingDashboardKpi()
    byModule: SubcontractorTrainingModuleBreakdown[] = []
    overdueInvites: SubcontractorTrainingOverdueRow[] = []
}

export class SubcontractorTrainingTrackingModule {
    moduleId!: string
    moduleTitle!: string
    isCompleted = false
    completedOn?: Date
    scoreCorrect = 0
    scoreTotal = 0
    completedFirstName = ''
    completedLastName = ''
    completedCompanyName = ''
    answers: SubcontractorTrainingCompletionAnswer[] = []
}

export class SubcontractorTrainingCompletionAnswer {
    questionText!: string
    selectedAnswer!: string
    correctAnswer!: string
    isCorrect = false
}

export class SubcontractorTrainingPublicInvite {
    inviteId!: string
    companyName!: string
    email!: string
    welcomeText!: string
    modules: SubcontractorTrainingPublicModule[] = []
}

export class SubcontractorTrainingParticipantSession {
    participantId!: string
    companyName!: string
    firstName!: string
    lastName!: string
    welcomeText!: string
    modules: SubcontractorTrainingPublicModule[] = []
}

export class SubcontractorTrainingParticipantSummary {
    participantId!: string
    firstName!: string
    lastName!: string
    completedModuleCount = 0
    totalModuleCount = 0
    isCompleted = false
}

export class SubcontractorTrainingPublicModule {
    moduleId!: string
    title!: string
    description!: string
    youTubeUrl!: string
    sortOrder = 0
    isCompleted = false
    questions: SubcontractorTrainingPublicQuestion[] = []
}

export class SubcontractorTrainingPublicQuestion {
    id!: string
    sortOrder = 0
    questionText!: string
    questionType: 'TrueFalse' | 'MultipleChoice' = 'TrueFalse'
    options: string[] = []
}

export class SubcontractorTrainingValidateAnswerResponse {
    isCorrect = false
    correctAnswer = ''
    explanation = ''
}

export class SubcontractorTrainingSubmitModuleResponse {
    success = false
    message = ''
    allModulesCompleted = false
}
